import { ASSISTANT, ECE, TEACHER } from '@BUP/constants'

const tawkPropertyId = import.meta.env.VITE_TAWK_PROPERTY_ID || '6126489cd6e7610a49b1f310'
const tawkWidgetId = import.meta.env.VITE_TAWK_WIDGET_ID || '1fduon8n5'
const tawkScriptUrl = import.meta.env.VITE_TAWK_SCRIPT_URL || `https://embed.tawk.to/${tawkPropertyId}/${tawkWidgetId}`

const supportedTawkRoles = [ASSISTANT, TEACHER, ECE]

export const isTawkWidgetEnabled = ({ organization, role }) => {
  const organizationNetwork = organization?.network
  const roleType = role?.type

  return organizationNetwork === 'BraveUPTest' && supportedTawkRoles.includes(roleType)
}

export const getTawkScriptConfig = () => ({
  scriptId: 'bup-tawk-widget-script',
  scriptSrc: tawkScriptUrl,
  propertyId: tawkPropertyId,
  widgetId: tawkWidgetId
})

export const initializeTawkScript = ({
  isEnabled,
  tawkScriptConfig = getTawkScriptConfig(),
  documentRef = document,
  windowRef = window
}) => {
  if (!isEnabled || !tawkScriptConfig?.scriptSrc) {
    windowRef?.Tawk_API?.hideWidget?.()
    return null
  }

  const existingScript = documentRef.getElementById(tawkScriptConfig.scriptId)

  if (existingScript) {
    windowRef?.Tawk_API?.showWidget?.()
    return existingScript
  }

  const script = documentRef.createElement('script')
  script.id = tawkScriptConfig.scriptId
  script.async = true
  script.src = tawkScriptConfig.scriptSrc
  script.charset = 'UTF-8'
  script.setAttribute('crossorigin', '*')

  const firstScript = documentRef.getElementsByTagName('script')[0]
  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript)
  }

  return script
}

export default getTawkScriptConfig()
